import createPlugin from '@shared/plugins/validate';
import { getCharLength } from '@shared/utils/commonUtils';
import defaultRules from '@shared/plugins/validate/rules';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ValidationErrors from '@shared/plugins/validate/components/ValidationErrors.vue';

/**
 * @param {ServiceManager} services
 * @return {{}}
 */
const makeRules = services => ({
  ...defaultRules,
  byEmail: defaultRules.email,
  uploadImage: defaultRules.required,
  requiredNoname: defaultRules.required,
  requiredSelect: defaultRules.required,
  requiredCheck: defaultRules.required,
  isPhoneNumber: value => /^\+(?=(?:\s?\d){7,17}$)\d+(?:\s?\d+){0,3}$/.test(value),
  accountLocked: () => !services.store.getState('auth', 'accountLocked'),
  emailRegistered: value => services.user.checkEmailRegistered(value),
  verificationCode: value => /^[A-Z0-9]+$/.test(value),
  nickname: value => /^[a-zA-Z0-9가-힣-_.'\s]+$/.test(value),
  nicknameRegistered: value => services.user.checkNicknameRegistered(value),
  summonerName: value => /^[0-9a-zA-Z \u3131-\u314e\u314f-\u3163\uac00-\ud7a3]+$/.test(value),
  hanaCoupon: value => /^Q[0-9A-Z]{6,7}$/.test(value),
  hanaCouponTeam: value => /^T[0-9A-Z]{6,7}$/.test(value),
  kartRider: value => /^[A-Za-z0-9가-힣]+$/.test(value) && getCharLength(value) >= 4 && getCharLength(value) <= 12,
  kartRiderRushPlus: value => /^.{2,12}$/.test(value) && getCharLength(value) >= 4,
  kartRiderRushPlusUid: value => /^[a-zA-Z0-9]{13}$/.test(value),
  randomToYou: value => /^[A-Z0-9]{7}$/.test(value),
  teamName: value => /^[a-zA-Z0-9가-힣-_.' ]+$/.test(value),
  timeRequired: value => value > 0,
  extraRequired: value => value.length > 0,
  sixPassword: value => (value.length === 0 || value.length === 6) && /^[0-9]+$/.test(value),
  confirm: {
    params: ['target'],
    validate: (value, { target }) => value === target,
  },
  channelTitleUsed: {
    params: ['specialId'],
    validate: (value, { specialId }) => services.channel.getValidatedTitle({ specialId, name: value }),
  },
  afterDate: {
    params: ['startTime'],
    validate: (value, { startTime }) => value > 0 && startTime > 0 && value > startTime,
  },
  selectedImage: {
    params: ['key'],
    // validate: (value, { key }) => value[`${key}Type`].length > 0,
    validate: value => Object.values(value).some(is => is),
  },
  teamNameVacated: {
    params: ['currentName'],
    validate: (value, { currentName }) => currentName === value || services.team.teamNameVacated(value),
  },
});

export default {
  install(Vue, { services }) {
    const { validate, extend } = createPlugin();
    // noinspection JSUnresolvedVariable
    if (!TARGET_NODE) {
      const rules = makeRules(services);
      extend(rules);
    }
    Vue.component('ValidationProvider', ValidationProvider);
    Vue.component('ValidationObserver', ValidationObserver);
    Vue.component('ValidationErrors', ValidationErrors);
    Vue.prototype.$validate = validate;

    // 아래와 같은 코드를 사용할 경우 iteration이 발생하여 에러 토스트의 에러 종류가 바뀜.
    // i.e. 에러 캐치 스코프가 현재 코드 내부인지, 컴포넌트 내부인지에 따라 에러 종류가 바뀜.
    // $getError()를 사용할 것
    // try {
    //   await this.$getError(this.$refs.validator);
    //   this.$scroll.scrollTo(0);
    // } catch (err) {
    //   throw err;
    // }

    // https://github.com/logaretm/vee-validate/issues/2395
    // 위와 같은 케이스에서 에러가 있을 경우 포커싱 및 스크롤 이벤트를 사용하기 위해서 작성
    // UserRecordEmpty.vue 참조
    Vue.prototype.$getError = async function (validator, errorCallback) {
      try {
        await Vue.prototype.$validate(validator, errorCallback);
        return null;
      } catch (err) {
        return err;
      }
    };
  },
};
